<div class="row">
  <div class="col-12">
    <div class="content-header">Credentials Form</div>
  </div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-md">
                <form [formGroup]="credentialsForm">
                  <fieldset class="form-group">
                    <label>Title</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="title" [(ngModel)]="credent_model.title"
                      id="title"
                      placeholder="Enter title"
                      [ngClass]="{
                        'is-invalid':
                          credentialsFormSubmitted && rf.title.invalid,
                        'is-valid': credentialsFormSubmitted && !rf.title.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="
                        rf.title.touched &&
                        (rf.title.invalid || rf.title.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> title is
                      required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>User Name</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="user_name" [(ngModel)]="credent_model.user_name"
                      id="user_name"
                      placeholder="Enter user name"
                      [ngClass]="{
                        'is-invalid':
                          credentialsFormSubmitted && rf.user_name.invalid,
                        'is-valid': credentialsFormSubmitted && !rf.user_name.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="
                        rf.user_name.touched &&
                        (rf.user_name.invalid || rf.user_name.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> user name is
                      required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Password</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="password"
                      [(ngModel)]="credent_model.password"
                      id="password"
                      placeholder="Enter password"
                      [ngClass]="{
                        'is-invalid':
                          credentialsFormSubmitted && rf.password.invalid,
                        'is-valid': credentialsFormSubmitted && !rf.password.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="
                        rf.password.touched &&
                        (rf.password.invalid || rf.password.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> password is
                      required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="name">Website Url</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="website_url"
                      [(ngModel)]="credent_model.website_url"
                      id="website_url"
                      placeholder="Enter website_url"
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Security Questions/Answers</label>
                    <p class="mt-1 mb-0">{{questions_data[0]?.question}}</p>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="answer"
                      [(ngModel)]="credent_model.secutity_questions[0].answer"
                      id="answer"
                      placeholder="Enter answer"
                    />
                  </fieldset> 
                  <fieldset class="form-group">
                    <label>Two-Factor Authentication</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="two_Factor_Authentication"
                      [(ngModel)]="credent_model.two_Factor_Authentication"
                      id="two_Factor_Authentication"
                      placeholder="Enter two_Factor_Authentication"
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Passcode</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="passcode"
                      [(ngModel)]="credent_model.passcode"
                      id="passcode"
                      placeholder="Enter passcode"
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Expiration Date</label>
                    <input
                      type="date"
                      class="form-control"
                      formControlName="experation_date"
                      [(ngModel)]="credent_model.experation_date"
                      id="experation_date"
                    />
                  </fieldset>
                </form>
              </div>
              <div class="col-md">
                <form [formGroup]="credentialsForm">
                  <fieldset class="form-group">
                    <label>Renewal Instructions</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="renewal_instructions"
                      [(ngModel)]="credent_model.renewal_instructions"
                      id="renewal_instructions"
                      placeholder="Enter renewal instructions"
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Support Contact</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="support_contact"
                      [(ngModel)]="credent_model.support_contact"
                      id="support_contact"
                      placeholder="Enter support contact"
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Primary Contact</label>
                    <input
                      placeholder="e.g. 1234-567-890"
                       mask="0000-000-000" minlength="10"
                       type="text"
                      class="form-control"
                      formControlName="primary_contact"
                      [(ngModel)]="credent_model.primary_contact"
                      id="primary_contact"
                      placeholder="Enter primary contact"
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <!-- <ng-select
                                          [items]="categories"
                                          bindLabel="displayname"
                                          bindValue="_id"
                                          [multiple]="true"
                                          [closeOnSelect]="false"
                                          placeholder="Select Tag Type"
                                          [(ngModel)]="selectedValue"
                                          [ngModelOptions]="{ standalone: true }"
                                          (change)="getCategoryId($event)"
                                        >
                                        </ng-select> -->
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="displayname">Alotedto</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="alote_dto"
                      [(ngModel)]="credent_model.alote_dto"
                      id="alote_dto"
                      placeholder="Enter alote dto"
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Access Level</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="access_level"
                      [(ngModel)]="credent_model.access_level"
                      id="access_level"
                      placeholder="Enter access level"
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="description">description</label>
                    <textarea
                      formControlName="description"
                      [(ngModel)]="credent_model.description"
                      id="hidden-label-form-6"
                      rows="1"
                      class="form-control"
                      name="comment2"
                      placeholder="Enter description"
                    ></textarea>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="notes">notes</label>
                    <textarea
                      formControlName="notes"
                      [(ngModel)]="credent_model.notes"
                      id="hidden-label-form-6"
                      rows="1"
                      class="form-control"
                      name="comment2"
                      placeholder="Enter notes"
                      [ngClass]="{
                        'is-invalid':
                          credentialsFormSubmitted && rf.notes.invalid,
                        'is-valid':
                          credentialsFormSubmitted && !rf.notes.invalid
                      }"
                      required
                      #notes
                    ></textarea>
                    <div
                      *ngIf="
                        rf.notes.touched &&
                        (rf.notes.invalid || rf.notes.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> notes is
                      required
                    </div>
                  </fieldset>

                  <div
                    class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                  >
                    <button
                      type="submit"
                      class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                      (click)="submit()"
                    >
                      Submit
                    </button>
                    <button type="reset" class="btn btn-secondary" (click)="back()">
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
